module.exports = __webpack_public_path__ + "media/warn.1fa017b6.mp3";